var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"logo",class:'logo--' + _vm.kind,attrs:{"role":"img","aria-label":_vm.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }